import { render, staticRenderFns } from "./AlarmConfiguration.vue?vue&type=template&id=04b0750e&scoped=true&"
import script from "./AlarmConfiguration.vue?vue&type=script&lang=js&"
export * from "./AlarmConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./AlarmConfiguration.vue?vue&type=style&index=0&id=04b0750e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0750e",
  null
  
)

export default component.exports